import { Component, OnInit } from "@angular/core";
import { select } from "@angular-redux/store";
import { ServiceControllerStatusEnum, WindowsService } from "../../../models/windows-service";
import { Observable } from "rxjs/Observable";
import { ChannelEvent } from "../../../../pb-screen/services/channel.event.factory";
import { Update } from "./models/update";

@Component({
  selector: "automatic-updates-v2",
  templateUrl: "./automatic-updates-v2.component.html",
  styleUrls: ["./automatic-updates-v2.component.scss"]
})
export class AutomaticUpdatesV2Component implements OnInit {

  @select("monitorService") monitoringService$: Observable<WindowsService>;
  @select("channelEvents") channelEvents$: Observable<ChannelEvent[]>;

  updates: Update[] = [];

  monitoringStatusPossibilities = ServiceControllerStatusEnum;

  ngOnInit(): void {
    this.channelEvents$.subscribe((response: ChannelEvent[]) => {
      this.updates = [];

      for (const event of response) {
        const data = JSON.parse(event.json).data;

        const update: Update = {
          type: data.type,
          timestamp: event.timestamp,
          newPlanningBlocks: data.newPlanningBlocks,
          updatedPlanningBlocks: data.updatedPlanningBlocks,
          deletedPlanningBlocks: data.deletedPlanningBlocks,
          newTransportOrders: data.newTransportOrders,
          updatedTransportOrders: data.updatedTransportOrders,
          deletedTransportOrders: data.deletedTransportOrders
        };

        this.updates.push(update);
      }

      this.updates.reverse();
    });
  }
}

